<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectCreationReason,
} from '../../../../model/additional-info/support/info-invoice-creation/select-creation-reason.hook'

defineOptions({
  name: 'SelectCreationReason',
})

const {
  placeholder,
  model,
  options,
} = useSelectCreationReason()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
